let code = 'psp';
let codeAPI = 'psp';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};